import angular from 'angular'

import { noargs } from '../utils/bits'
import { wrap, once } from 'lodash-es'

import Emitter from '../utils/emitter'
import SumEmitter from '../utils/sum-emitter'
import attachSetters from '../utils/attach-setters'
import attachGetters from '../utils/attach-getters'

angular
  .module('ggs.gallery')
  .factory('ReadyStateManager', ReadyStateManagerProvider)

function ReadyStateManagerProvider(qh, DefineMethod) {
  return function ReadyStateManager(
    properties,
    postFlagEmitter,
    mainCanFetchPosts,
    postListManager
  ) {
    const sign = 'galleryMain::ReadyStateManager'

    const testEmitter = SumEmitter(
      postFlagEmitter,
      properties.key2emitter.show_load_more_button,
      postListManager.fetchBelowEmitter,
      postListManager.preloadBelowEmitter,
      postListManager.setupTopPostsEmitter
    )

    const readyEmitter = Emitter(`${sign}::readyEmitter`)
    const loadedEmitter = Emitter(`${sign}::loadedEmitter`)

    const manager = attachGetters(attachSetters({
      wrapM: DefineMethod(sign),
      isReady: false,
      isLoaded: false,
      readyEmitter,
      loadedEmitter
    }))

    manager.wrapM('testIfReady',
      qh.makeIf(
        isReady,
        qh.makeOver(
          manager.setters.bindTrue.isReady,
          noargs(once(readyEmitter.emit)))))

    manager.wrapM('testIfLoaded',
      qh.makeIf(
        isLoaded,
        qh.makeOver(
          manager.setters.bindTrue.isLoaded,
          noargs(once(loadedEmitter.emit)))))

    manager.wrapM('test',
      qh.makeOver(
        manager.testIfReady,
        manager.testIfLoaded))

    manager.wrapM('init',
      qh.makeOver(
        wrap(manager.test, testEmitter.on),
        manager.test))

    manager.wrapM('destroy',
      wrap(manager.test, testEmitter.off))

    return manager

    function isReady() {
      return false
        || postListManager.zeroPosts()
        || postListManager.somePostDone()
        || postListManager.everyPostFail()
    }

    function isLoaded() {
      if (mainCanFetchPosts()) {
        return isReady()
      }

      if (!postListManager.isPostListReady() || !postListManager.isUnprocessedBelowListEmpty() || !postListManager.isPendingChunksEmpty()) {
        return false
      }

      if (postListManager.isAllBelowPostsFetched()) {
        return true
      }

      return postListManager.isTopLimitReached() && postListManager.ranPreloadedBelowPosts()
    }
  }
}
